import { FC, HTMLAttributes, ReactNode } from 'react';

interface TableBodyProps extends HTMLAttributes<HTMLTableSectionElement> {
  children: ReactNode;
  className?: string;
}

export const TableBody: FC<TableBodyProps> = ({
  children,
  className = '',
  ...props
}) => (
  <tbody className={className} {...props}>
    {children}
  </tbody>
);
